import { render, staticRenderFns } from "./ModalCustomDomainInfo.vue?vue&type=template&id=623e7f4e&scoped=true"
import script from "./ModalCustomDomainInfo.vue?vue&type=script&lang=js"
export * from "./ModalCustomDomainInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e7f4e",
  null
  
)

export default component.exports